import { DocumentData, QueryDocumentSnapshot } from "firebase/firestore"
import { RecordType } from "../Type"

export const getRecordTypeFromDocSnapshot = (
  doc: QueryDocumentSnapshot<DocumentData, DocumentData>
): RecordType => {
  return {
    id: doc.id,
    name: doc.data().name,
    insertDate: doc.data().insertDate,
    lastEditDate: doc.data().lastEditDate,
  }
}
